import React from "react";
import { FaGlobe } from 'react-icons/fa';
import { GoMarkGithub } from 'react-icons/go';

import Overlay from "../overlay/overlay.component";
import './project.styles.scss';

class Project extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      overlayOn: false
    }
  }

  toggleOverlay() {
    const { overlayOn } = this.state;
    this.setState({ overlayOn: !overlayOn });
  }

  render() {
    const { title, link, icon, languages, tools, description, github, images } = this.props;
    const { overlayOn } = this.state;

    return (
      <div className="project">
        <div className='project-left'>
          <img alt={title} src={icon} className='project-icon' />
          <input type='button' value='Click me!' className='project-overlay-button center' onClick={() => this.toggleOverlay()} />
        </div>

        <div className='project-text'>
          <div className='project-header'>
            <h1 className='project-title'>{title}</h1>
            {link.length !== 0 ? <a target='_blank' rel='noreferrer' href={link} className='project-link'><FaGlobe size={30} /></a> : null}
            <a target='_blank' rel='noreferrer' href={github} className='project-link'><GoMarkGithub size={30} /></a>
          </div>
          <p className='project-content'>
            <b>Languages: </b>{languages.join(', ')}<br />
            {tools.length !== 0 ? <><b>Tools: </b>{tools.join(', ')}<br /></> : null}
            <b>Description: </b>{description}<br />
          </p>
        </div>

        <Overlay images={images} visible={overlayOn} toggle={() => this.toggleOverlay()} />

        <hr className='mid' />
      </div>
    );
  }
};

export default Project;
